import { render, staticRenderFns } from "./hitchhikingDetails.vue?vue&type=template&id=72c51ce6&scoped=true"
import script from "./hitchhikingDetails.vue?vue&type=script&lang=js"
export * from "./hitchhikingDetails.vue?vue&type=script&lang=js"
import style0 from "./hitchhikingDetails.vue?vue&type=style&index=0&id=72c51ce6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c51ce6",
  null
  
)

export default component.exports